var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:round-arrow-right-alt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6746 7.33371H3.33464C2.96797 7.33371 2.66797 7.63371 2.66797 8.00038C2.66797 8.36704 2.96797 8.66704 3.33464 8.66704H10.6746V9.86038C10.6746 10.1604 11.0346 10.307 11.2413 10.0937L13.0946 8.23371C13.2213 8.10038 13.2213 7.89371 13.0946 7.76038L11.2413 5.90038C11.0346 5.68704 10.6746 5.84038 10.6746 6.13371V7.33371Z",
    fill: "#5B5B5B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.63d80106363f6a8c0b9b48a2917dfea8.svg";
export { ForwardRef as ReactComponent };